import React, { useEffect, useRef, useContext, useState, forwardRef } from "react";
import "./widgetcss/styles.css";
import { MapContext } from "../MapContext";

import { infoLayer, infoLayerHours, uniquePeople } from "../Services/serviceLayers";

import bikeInactive from "../icons/BikeInactive.png";
import carInactive from "../icons/CarInactive.png";
import busInactive from "../icons/BusInactive.png";
import humanInactive from "../icons/HumanInactive.png";

import { calculatePercentagesFromTotal } from "../helpers/helper";
import { set } from "date-fns";

// informacine kortele rodoma po prisijungimo arba paspaudus "i" mygtuka heatmap'e
// paquerinamas vienas servias ir jo duomenys sudedami i kortele
export default function InfoCard () {

    const na = 'N/A'
    const collumn = [ na, na, na, na, na]
    const table = {"Car": collumn, "Bike":collumn, "Pedestrian":collumn, "Bus":collumn}
    const mapContext = useContext(MapContext);
    const [showCard, setShowCard] = useState(true);
    const [infoTableData, setInfoTableData] = useState(table)
    const [infoTableDataEvening, setInfoTableDataEvening] = useState(table)
    const [infoTableDataMorning, setInfoTableDataMorning] = useState(table)
    const [infoTableAll, setInfoTableAll] = useState([infoTableDataEvening, infoTableData , infoTableDataMorning])

    const [currentDate, setCurrentDate] = useState("MMMM.MM.DD")
    const [weekday, setWeekday] = useState("-")
    const [totalUsage, setTotalUsage] = useState("-")
    const [shownTime, setShownTime] = useState(0)

    const infoTitle = [
    "Centrinė zona",
    "Vidurinioji zona",
    "Vilniaus miestas",
    "Periferija ir algomeracija",
    "Vilniaus miestas su aglomeracija"
    ]

    /*const infoKeys = {
        "{F5D0FB27-9962-4D62-844C-F4DE80C7559D}" : "Periferija ir algomeracija",
        "{4C9A06CC-A857-40A7-BCAF-C4375CE4B44F}" : "Vilniaus miestas",
        "{0BBD4D2A-23F7-4F6C-A808-945C9FCE738E}" : "Vidurinioji zona",
        "{53A3B397-5FFA-48B0-B3BC-CBB4C1E31D5F}":  "Centrinė zona",
        "{05F8EFA6-E42B-4B8F-835D-1AE47157E646}":  "Vilniaus miestas su aglomeracija"
    }*/

    const infoKeys = {
        "{B659FD4F-3C6B-400A-9639-D314AB56FBE6}" : "Periferija ir algomeracija",
        "{86D92237-783C-4ECC-A64F-964E9160DF0A}" : "Vilniaus miestas",
        "{C243D6F7-65C9-4628-A80C-5758CD81FCBB}" : "Vidurinioji zona",
        "{34F55CEC-74C7-4A7B-90C0-65A060B54FB9}":  "Centrinė zona",
        "{5DB6140F-3155-40D6-9485-AF96D37DD4AB}":  "Vilniaus miestas su aglomeracija"
    }

    const infoKeysHours = {
        "{DD515FCB-012A-4893-9F5C-FBA056C9950A}" : "Periferija ir algomeracija",
        "{3CF7F1EF-AEA2-4D92-8D6B-F17CF508A4CB}" : "Vilniaus miestas",
        "{E1FE0616-ABC9-4FF3-9915-B82A8ADBE606}" : "Vidurinioji zona",
        "{F63E2E08-3ED9-43B1-ACE6-E0EF2EA19517}":  "Centrinė zona",
        "{DE559575-1BED-4163-B9A1-60C71A5C3E6A}":  "Vilniaus miestas su aglomeracija"
    }

    const infoData = {
        "Centrinė zona" : 0,
        "Vidurinioji zona" : 1,
        "Vilniaus miestas": 2,
        "Periferija ir algomeracija": 3,
        "Vilniaus miestas su aglomeracija": 4
    }


    
    const infoKeysTransport = {
        "0" :"Car",
        "1" :"Bike",
        "2" : "Pedestrian",
        "3" :"Bus"
    }

    const infoCardRef = useRef(null);

    const handleClickOutside = (event) => {
        if (infoCardRef.current && !infoCardRef.current.contains(event.target)) {
        setShowCard(false);
        }
    };

    const changeSetShownTime = (change) => {
        let newTime = shownTime + change
        if (newTime < 0) {
            newTime = 0
        }
        if (newTime > 2) {
            newTime = 2
        }
        setShownTime(newTime)
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {  
        if (mapContext.state.callPopup === true) {
            setShowCard(true);
            mapContext.dispatch({
                callPopup: false,
            });
        }   
    }, [mapContext.state.callPopup]);

    useEffect(() => {
        



    let query = infoLayer.createQuery();
        query.where = '1=1'
        query.outFields = ['timestamp']
        query.returnDistinctValues = true
        query.orderByFields = ['timestamp DESC']

        infoLayer.queryFeatures(query).then((result) => {

            //console.log(result)
            const timestamps = result.features.map(feature => feature.attributes.timestamp);

            const largestTimestamp = Math.max(...timestamps);

            const date = new Date(largestTimestamp);

            

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const formattedDate = `${year}.${month}.${day}`;

            query = infoLayer.createQuery();
            query.where = 'totalUserCount > 0'
            query.outFields = ['totalUserCount', 'timestamp']
            query.orderByFields = ['timestamp DESC']
            query.num = 1

            infoLayer.queryFeatures(query).then((result) => {
                let sameDay = (
                    date.getDate() === new Date(result.features[0].attributes.timestamp).getDate() &&
                    date.getMonth() === new Date(result.features[0].attributes.timestamp).getMonth() &&
                    date.getFullYear() === new Date(result.features[0].attributes.timestamp).getFullYear()
                )
                if (result.features.length > 0 && sameDay) {
                    setTotalUsage(result.features[0].attributes.totalUserCount)
                }
            }).catch((error) => {
                console.error('queryFeatures failed, layer:' , infoLayer , ' query:' , query , ' error:', error);
            });

            const weekdays = ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'];
            const weekday = weekdays[date.getDay()];

            //console.log('Largest timestamp:', largestTimestamp);
            //console.log('Formatted date:', formattedDate);
            //console.log('Weekday:', weekday);
            setCurrentDate(formattedDate)
            setWeekday(weekday)

            const formattedDatequery = `${year}-${month}-${day}`;
            let timestampQuery = infoLayer.createQuery();
            timestampQuery.where =  `timestamp = date'${formattedDatequery}'`
            timestampQuery.outFields = ['*']


            const tableTemp = {"Car": ['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Bike":['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Pedestrian":['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Bus":['N/A', 'N/A', 'N/A', 'N/A', 'N/A']}
            //console.log(tableTemp)
            infoLayer.queryFeatures(timestampQuery).then((result) => {
                //console.log('timestamp:', result.features);
                let tempTable = tableTemp
                //console.log(tableTemp)
                result.features.forEach(element => {
                    const usageType = element.attributes.usageType;
                    const zoneId = element.attributes.zoneId;
                    const usageCount = element.attributes.usageCount;


                    if (!tableTemp[usageType]) {
                        tableTemp[usageType] = {};
                    }
                    
                    const infoKey = infoKeys[zoneId];
                    const infoValue = infoData[infoKey];
                    const infoKeyTransport = infoKeysTransport[usageType]
                    
                    tableTemp[infoKeyTransport][infoValue] = usageCount;
                });
                delete tableTemp["0"]
                delete tableTemp["1"]
                delete tableTemp["2"]
                delete tableTemp["3"]
                let i
                for (i = 0; i < 5; i++){
                    let totalSum = 0
                    for (const key of Object.keys(tableTemp)) {
                        totalSum += parseInt(tableTemp[key][i])
                    }
                    let zoneNumbers = [tableTemp.Car[i], tableTemp.Bus[i], tableTemp.Pedestrian[i], tableTemp.Bike[i]]
                    let zonePercentage = calculatePercentagesFromTotal(zoneNumbers, totalSum)

                    tableTemp.Car[i] = zonePercentage[0].toFixed(1) + "%"
                    tableTemp.Bus[i] = zonePercentage[1].toFixed(1) + "%"
                    tableTemp.Pedestrian[i] = zonePercentage[2].toFixed(1) + "%"
                    tableTemp.Bike[i] = zonePercentage[3].toFixed(1) + "%"
                }
                setInfoTableData(tableTemp)

                
            })
            .catch((error) => {
                console.error('queryFeatures failed, layer:' , infoLayer , ' query:' , query , ' error:', error);
            });


        })
        .catch((error) => {
        console.error('queryFeatures failed, layer:' , infoLayer , ' query:' , query , ' error:', error);
        });

        query = infoLayerHours.createQuery(); 
        query.where = '1=1'
        query.outFields = ['timestamp']
        query.returnDistinctValues = true
        query.orderByFields = ['timestamp DESC']


        infoLayer.queryFeatures(query).then((result) => {

            //console.log(result)
            const timestamps = result.features.map(feature => feature.attributes.timestamp);
      
            const largestTimestamp = Math.max(...timestamps);

            const date = new Date(largestTimestamp);

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
            const day = date.getDate().toString().padStart(2, '0');

            const formattedDatequery = `${year}/${month}/${day}`;
            let timestampQuery = infoLayer.createQuery(); 
            timestampQuery.where =  `timestamp > timestamp'${formattedDatequery} 00:00:00' AND timestamp < timestamp'${formattedDatequery} 23:59:59'`
            //console.log(timestampQuery.where)
            timestampQuery.outFields = ['*']

            let tableTemp = {"Car": ['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Bike":['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Pedestrian":['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Bus":['N/A', 'N/A', 'N/A', 'N/A', 'N/A']}
            //console.log(tableTemp)
            infoLayer.queryFeatures(timestampQuery).then((result) => {
                
                //console.log('timestamp:', result.features);
                let tempTable = tableTemp
                //console.log(tableTemp)
                const uniqueTimestamps = [...new Set(result.features.map(d => d.attributes.timestamp))].sort((a, b) => a - b);

                //console.log(uniqueTimestamps)
                const earlyTimestamps = uniqueTimestamps.slice(0, 3);
                const laterTimestamps = uniqueTimestamps.slice(3);

                const early = result.features.filter(d => earlyTimestamps.includes(d.attributes.timestamp));
                const later = result.features.filter(d => laterTimestamps.includes(d.attributes.timestamp));
                //console.log(early)
                //console.log(later)
                
                early.forEach(element => {
                    const usageType = element.attributes.usageType;
                    const zoneId = element.attributes.zoneId;
                    const usageCount = element.attributes.usageCount;


                    if (!tableTemp[usageType]) {
                        tableTemp[usageType] = {};
                    }
                    
                    //console.log(zoneId)
                    //console.log(infoKeys)
                    
                    //Reikia atnaujintu zodeId 
                    const infoKey = infoKeys[zoneId];
                    //console.log(infoKey)
                    const infoValue = infoData[infoKey];
                    const infoKeyTransport = infoKeysTransport[usageType]
                    
                    tableTemp[infoKeyTransport][infoValue] = usageCount;
                    //console.log(tableTemp[infoKeyTransport][infoValue],infoKeyTransport,infoValue)
                });
                //console.log(tableTemp)
                //(tableTemp)
                delete tableTemp["0"]
                delete tableTemp["1"]
                delete tableTemp["2"]
                delete tableTemp["3"]
                let i
                for (i = 0; i < 5; i++){
                    let totalSum = 0
                    for (const key of Object.keys(tableTemp)) {
                        totalSum += parseInt(tableTemp[key][i])
                    }
                    let zoneNumbers = [tableTemp.Car[i], tableTemp.Bus[i], tableTemp.Pedestrian[i], tableTemp.Bike[i]]
                    let zonePercentage = calculatePercentagesFromTotal(zoneNumbers, totalSum)

                    tableTemp.Car[i] = zonePercentage[0].toFixed(1) + "%"
                    tableTemp.Bus[i] = zonePercentage[1].toFixed(1) + "%"
                    tableTemp.Pedestrian[i] = zonePercentage[2].toFixed(1) + "%"
                    tableTemp.Bike[i] = zonePercentage[3].toFixed(1) + "%"
                }
                //console.log(tableTemp)
                setInfoTableDataMorning(tableTemp)
                tableTemp = {"Car": ['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Bike":['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Pedestrian":['N/A', 'N/A', 'N/A', 'N/A', 'N/A'], "Bus":['N/A', 'N/A', 'N/A', 'N/A', 'N/A']}
                
                
                later.forEach(element => {
                    const usageType = element.attributes.usageType;
                    const zoneId = element.attributes.zoneId;
                    const usageCount = element.attributes.usageCount;


                    if (!tableTemp[usageType]) {
                        tableTemp[usageType] = {};
                    }
                    //Reikia atnaujintu zodeId 
                    const infoKey = infoKeys[zoneId];
                    const infoValue = infoData[infoKey];
                    const infoKeyTransport = infoKeysTransport[usageType]
                    
                    tableTemp[infoKeyTransport][infoValue] = usageCount;
                    //console.log(tableTemp[infoKeyTransport][infoValue], usageCount)
                });
                delete tableTemp["0"]
                delete tableTemp["1"]
                delete tableTemp["2"]
                delete tableTemp["3"]
                for (i = 0; i < 5; i++){
                    let totalSum = 0
                    for (const key of Object.keys(tableTemp)) {
                        totalSum += parseInt(tableTemp[key][i])
                    }
                    let zoneNumbers = [tableTemp.Car[i], tableTemp.Bus[i], tableTemp.Pedestrian[i], tableTemp.Bike[i]]
                    let zonePercentage = calculatePercentagesFromTotal(zoneNumbers, totalSum)

                    tableTemp.Car[i] = zonePercentage[0].toFixed(1) + "%"
                    tableTemp.Bus[i] = zonePercentage[1].toFixed(1) + "%"
                    tableTemp.Pedestrian[i] = zonePercentage[2].toFixed(1) + "%"
                    tableTemp.Bike[i] = zonePercentage[3].toFixed(1) + "%"
                }
                //console.log(tableTemp)
                setInfoTableDataEvening(tableTemp)

                

                
            })
            .catch((error) => {
                console.error('queryFeatures failed, layer:' , infoLayerHours , ' query:' , timestampQuery , ' error:', error);
            });


        })
        .catch((error) => {
        console.error('queryFeatures failed, layer:' , infoLayerHours , ' query:' , query , ' error:', error);
        });

        
    },[])


    useEffect(() => {   
        setInfoTableAll([infoTableData, infoTableDataMorning, infoTableDataEvening])
    }, [infoTableData, infoTableDataEvening, infoTableDataMorning])



      


    return (
        <>
        {
            showCard === false ? <> </> :
          <div id = "InfoCard"  ref={infoCardRef}>
            <div id = "InfoCardClose" onClick={() => {setShowCard(false)}}>X</div>
            <div id = "InfoCardTitle">JUDUMAS</div>
            <div id = "InfoCardDate">{currentDate
            + " " + (shownTime === 0 ? "" : shownTime === 1 ? "(7:00-9:00)" : "(16:00-18:00)")} 
            <br/>
            {weekday}
            <br/>
            Unikalių naudotojų skaičius: {totalUsage}
            </div>
            {shownTime > 0 ? <div className = "InfoCardChange" id="InfoCardChangePrev" onClick={() => {changeSetShownTime(-1)}}>{'<'}</div> : <></>}
            {shownTime < 2 ? <div className = "InfoCardChange" id="InfoCardChangeNext"onClick={() => {changeSetShownTime(1)}}>{'>'}</div> : <></>}
            <table id = "InfoTable">
                <tr>
                    <th>
                    </th>
                    <th>
                        <div id="CarIconInfoCard" className="IconContainer Icon IconTable">
                            <img
                            id="CarIconImgInfoCard"
                            className="ready3 img padding imgInfo"
                            src={carInactive}
                            alt="car"
                            ></img>
                        </div>
                    </th>
                    <th>
                        <div id="BusIconInfoCard" className="IconContainer Icon IconTable">
                            <img
                            id="BusIconImgInfoCard"
                            className="ready3 img padding imgInfo"
                            src={busInactive}
                            alt="bus"
                            ></img>
                        </div>
                    </th>
                    <th>
                        <div id="HumanIconInfoCard" className="IconContainer Icon IconTable">
                            <img
                            id="HumanIconImgInfoCard"
                            className="ready3 img padding imgInfo "
                            src={humanInactive}
                            alt="pedestrian"
                            ></img>
                        </div>
                    </th>
                    <th>
                        <div id="BikeIconInfoCard" className="IconContainer Icon IconTable">
                            <img
                            id="BikeIconImgInfoCard"
                            className="ready3 img padding imgInfo "
                            src={bikeInactive}
                            alt="bike"
                            ></img>
                        </div>
                    </th>
                </tr>
                <tr>
                    <td>
                        {infoTitle[0]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Car"][0]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bus"][0]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Pedestrian"][0]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bike"][0]}
                    </td>
                </tr>
                <tr>
                    <td >
                        {infoTitle[1]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Car"][1]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bus"][1]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Pedestrian"][1]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bike"][1]}
                    </td>
                </tr>
                <tr>
                    <td>
                        {infoTitle[2]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Car"][2]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bus"][2]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Pedestrian"][2]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bike"][2]}
                    </td>
                </tr>
                <tr>
                    <td>
                        {infoTitle[3]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Car"][3]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bus"][3]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Pedestrian"][3]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bike"][3]}
                    </td>
                </tr>
                <tr>
                    <td>
                        {infoTitle[4]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Car"][4]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bus"][4]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Pedestrian"][4]}
                    </td>
                    <td className="InfoTableCol">
                        {infoTableAll[shownTime]["Bike"][4]}
                    </td>
                </tr>
            </table>
          </div>

        } 
        </>
    )
}